import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../shared/auth/auth.service';
import { Router } from '@angular/router';
import { Logging } from '../../logging';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      // return true;
      if(this.auth.isLoggedIn())
      {
        return true;
      }
      else
      {
        Logging.log("r==>"+state.url);
        if(state.url && state.url.indexOf('/cashout/approve?r=')== 0) // has an approval link
        {
          this.auth.setApprovalLink(state.url);
        }
        this.router.navigate(['/login'],{
          queryParams: {
            return: state.url
          }
        });
        return false;
      }
      
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guards/auth.guard.ts